import styled from "styled-components";
import { theme } from "../../styles/theme";

export const StyledButton = styled("button")<{ color?: string; variant?: "primary" | "outline" }>`
  background: ${(p) =>
    p.variant === "outline" ? "transparent" : p.color || theme.colors.button};
  color: ${(p) =>
    p.variant === "outline" ? theme.colors.button : p.color ? theme.colors.button : theme.colors.white};
  font-family: ${theme.fonts.body};
  font-size: 0.9375rem;
  font-weight: 600;
  width: ${(p) => (p.variant === "outline" ? "auto" : "100%")};
  border: 1.5px solid ${theme.colors.button};
  border-radius: ${theme.radius.pill};
  padding: 0.875rem 1.75rem;
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: ${(p) => (p.variant === "outline" ? "none" : "220px")};
  transition: all 0.25s ease;
  white-space: nowrap;

  &:hover,
  &:active,
  &:focus {
    background: ${(p) =>
      p.variant === "outline" ? theme.colors.button : theme.colors.buttonHover};
    color: ${theme.colors.white};
    border-color: ${theme.colors.buttonHover};
    transform: translateY(-1px);
  }
`;
